<section fxLayout="row" class="h-100">
    <sen-app-welcome fxFlex="1 1 auto" *ngIf="!global.selectedProject"></sen-app-welcome>
    <section fxFlex="1 1 auto" class="sen-body-max-width" *ngIf="global.selectedProject">
        <section fxLayout="column" class="h-100">
            <nav class="sen-info-color-bg text-black" mat-tab-nav-bar>
                <span mat-tab-link *ngFor="let link of manageProjectsTabLink" (click)="activeLink = link.link"
                    [routerLink]="[link.link]" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
                    {{translate.getLng(link.label)}} </span>
            </nav>
            <router-outlet></router-outlet>
        </section>
    </section>
    <section class="sen-tool-bar sen-light-blue-bg">
        <div class="h-100" fxLayout="column">
            <h2 class="pl-2 pt-2">{{translate.getLng('MANAGE')}}</h2>
            <mat-card class="sen-form-field-wrapper m-2">
                <mat-form-field appearance="none" class="w-100">
                    <mat-label>{{translate.getLng('SEARCH')}} {{translate.getLng('PROJECT')}}
                        {{translate.getLng('NAME')}}</mat-label>
                    <input [maxlength]="global.maxStringLength" matInput senAppSearchDelay
                        [(ngModel)]="projectNameSearchString" autocomplete="off"
                        (delayedInput)="projectSearchCall($event)">
                    <mat-icon class="sen-active-color" matSuffix>search</mat-icon>
                </mat-form-field>
            </mat-card>
            <button mat-raised-button color="primary" class="px-4 py-1 w-75 mx-auto mb-1"
                [routerLink]="[createProjectLink]" [queryParams]="{ action: global.createProject }">
                <mat-icon>add</mat-icon> {{translate.getLng('NEW_PROJECT')}}
            </button>
            <div fxFlex="1 1 auto" class="my-1" fxLayout="column" fxLayoutAlign="flex-start stretch">
                <mat-card (click)="getSelectedProject(p, $event)" fxLayout="column"
                    fxLayoutAlign="space-between stretch"
                    [ngClass]="checkSelectedProjectId(p.id) ? 'active bg-white mr-2  pl-3' : 'mx-2'"
                    class="sen-menu-blue-bg  p-2 sen-cursor-pointer font-weight-bold my-1"
                    *ngFor="let p of (projects$ | async)?.projects">
                    <p class="sen-overflow-ellipsis text-left mb-0">{{p.name}}</p>
                    <span class="d-block text-white sen-fs10">{{translate.getLng('UPDATED_DATE_STRING')}}:
                        {{p.updated}}</span>
                </mat-card>
                <p class="text-center" *ngIf="!(projects$ | async)?.projects.length && projectNameSearchString">
                    {{translate.getLng('NO_PROJECT_MESSAGE')}}</p>
            </div>
            <sen-app-paginator-goto [length]="(projects$ | async)?.projectCount" [pageIndex]="initialPageIndex"
                [pageSize]="itemsPerPage" [pageSizeOptions]="[5, 10, 25, 100]" (page)="paginationChange($event)">
            </sen-app-paginator-goto>
        </div>
    </section>
</section>